/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import env from 'env'

export const getAppConfig = (meta?: any) => ({
  type: 'api/CONFIG/GET_CONFIG',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/settings',
      method: 'GET',
    },
  },
  meta,
})
getAppConfig.toString = () => 'api/CONFIG/GET_CONFIG'

export const getRecaptchaWhiteListConfig = (meta?: any) => ({
  type: 'api/WHITELIST/GET_WHITE_LIST',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/configuration/whitelist',
      method: 'GET',
    },
  },
  meta,
})
getRecaptchaWhiteListConfig.toString = () => 'api/WHITELIST/GET_WHITE_LIST'
